/* eslint-disable @typescript-eslint/no-unused-vars */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { initializeApp } from 'firebase/app'; 
import { getAuth } from 'firebase/auth';  // Import Firebase Auth
import { environment } from 'src/environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { FormatStringPipe } from './common/format-string.pipe';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { SpinnerComponent } from './mq/components/spinner/spinner.component';
import { SharedModule } from './mq/shared/shared.module';
import { DatePipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';




@NgModule({
  declarations: [AppComponent,],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),  
    SharedModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatTooltipModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideAnimationsAsync(),DatePipe
  ],
  bootstrap: [AppComponent,],
})
export class AppModule {
  constructor() {
    // Initialize Firebase
    initializeApp(environment.firebaseConfig);
    // You can also initialize Firebase Auth if required
    const auth = getAuth();
  }
}
